import React, { useEffect, useState } from 'react';
import Footer from './Footer';
import Header from './Header';
import Layout from './Layout';

const PrivacyPolicy = () => {
  const [headingStyle, setHeadingStyle] = useState({ fontSize: '32px' });

  useEffect(() => {
    window.scrollTo(0, 0);

    const updateHeadingSize = () => {
      const width = window.innerWidth;
      if (width < 480) {
        setHeadingStyle({ fontSize: '20px' });
      } else if (width < 768) {
        setHeadingStyle({ fontSize: '24px' });
      } else if (width < 1024) {
        setHeadingStyle({ fontSize: '28px' });
      } else {
        setHeadingStyle({ fontSize: '32px' });
      }
    };

    updateHeadingSize();
    window.addEventListener('resize', updateHeadingSize);
    return () => window.removeEventListener('resize', updateHeadingSize);
  }, []);

  return (
    <>
            {/* <Header /> */}
                        <Layout>
      <div style={styles.container}>
        <h1 style={headingStyle}>
          Privacy Policy
        </h1>

        <h2>1. Introduction</h2>
        <p>
          RZTO ("we," "our," or "us") is committed to protecting your privacy.
          This Privacy Policy outlines how we collect, use, and safeguard your
          personal information in relation to our Initial Coin Offering (ICO). By
          participating in our ICO, you agree to the collection and use of
          information in accordance with this policy.
        </p>

        <h2>2. Information We Collect</h2>
        <p>We may collect and process the following types of personal information:</p>
        <ul style={styles.list}>
          <li><strong>Identity Information:</strong> Full name, date of birth, nationality, and government-issued identification numbers.</li>
          <li><strong>Contact Information:</strong> Residential address, email address, and telephone number.</li>
          <li><strong>Financial Information:</strong> Bank account details, cryptocurrency wallet addresses, and transaction history related to the ICO.</li>
          <li><strong>KYC/AML Documentation:</strong> Information and documents required to comply with Know Your Customer (KYC) and Anti-Money Laundering (AML) regulations.</li>
          <li><strong>Technical Data:</strong> IP address, browser type and version, time zone setting, browser plug-in types and versions, operating system, and platform.</li>
        </ul>

        <h2>3. How We Use Your Information</h2>
        <p>Your personal information is used for the following purposes:</p>
        <ul style={styles.list}>
          <li><strong>To Facilitate Participation:</strong> Processing your application and enabling your participation in the ICO.</li>
          <li><strong>Compliance:</strong> Adhering to legal and regulatory obligations, including KYC and AML requirements.</li>
          <li><strong>Communication:</strong> Informing you about important updates, changes, and developments related to the ICO.</li>
          <li><strong>Security:</strong> Protecting against fraud, unauthorized transactions, and other illegal activities.</li>
          <li><strong>Improvement of Services:</strong> Enhancing our ICO platform and user experience based on feedback and usage patterns.</li>
        </ul>

        <h2>4. Sharing Your Information</h2>
        <p>We may share your personal information with:</p>
        <ul style={styles.list}>
          <li><strong>Service Providers:</strong> Third-party vendors who assist in KYC/AML verification, payment processing, and other operational services.</li>
          <li><strong>Regulatory Authorities:</strong> Law enforcement or governmental agencies when required by law or to protect our legal rights.</li>
          <li><strong>Affiliates:</strong> Entities within our corporate group for purposes consistent with this Privacy Policy.</li>
        </ul>
        <p>We do not sell, rent, or trade your personal information to third parties for their marketing purposes.</p>

        <h2>5. Data Security</h2>
        <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure.</p>

        <h2>6. Data Retention</h2>
        <p>We retain your personal information only as long as necessary to fulfill the purposes outlined in this Privacy Policy, comply with legal obligations, resolve disputes, and enforce our agreements. Specific retention periods depend on the nature of the information and legal requirements.</p>

        <h2>7. Your Rights</h2>
        <p>Depending on your jurisdiction, you may have the following rights regarding your personal information:</p>
        <ul style={styles.list}>
          <li><strong>Access:</strong> Request a copy of the personal information we hold about you.</li>
          <li><strong>Correction:</strong> Request correction of any inaccurate or incomplete information.</li>
          <li><strong>Deletion:</strong> Request deletion of your personal data, subject to legal and contractual obligations.</li>
          <li><strong>Objection:</strong> Object to the processing of your personal information under certain circumstances.</li>
        </ul>
        <p>To exercise these rights, please contact us at [Insert Contact Information].</p>

        <h2>8. Cookies and Tracking Technologies</h2>
        <p>Our ICO platform may use cookies and similar tracking technologies to enhance user experience. You can set your browser to refuse all or some browser cookies or to alert you when websites set or access cookies. Disabling cookies may affect the functionality of our platform.</p>

        <h2>9. Children's Privacy</h2>
        <p>Our ICO is not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If we become aware that we have inadvertently collected such information, we will take steps to delete it.</p>

        <h2>10. International Data Transfers</h2>
        <p>Your personal information may be transferred to and processed in countries other than your own. We ensure that such transfers comply with applicable data protection laws and that appropriate safeguards are in place.</p>

        <h2>11. Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy on our website and updating the effective date. Your continued participation in the ICO after such changes constitutes your acceptance of the new Privacy Policy.</p>

        <h2>12. Contact Us</h2>
        <p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:</p>
        <p><strong>RZTO</strong></p>
        <p>Email: care@rzto.io</p>

        <p><strong>By participating in the RZTO ICO, you acknowledge that you have read, understood, and agreed to this Privacy Policy.</strong></p>
      </div>
      </Layout>

    </>
  );
};

  const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.6',
    padding: '20px',
    color: '#333',
    margin: '30px auto',
    maxWidth: '70%',
    width: '100%',
    boxSizing: 'border-box',
    textAlign: 'justify', // justifies paragraph text
  },
  effectiveDate: {
    fontWeight: 'bold',
    marginBottom: '20px',
    textAlign: 'center', // center the effective date text
  },
  list: {
    listStyleType: 'disc',
    paddingLeft: '20px',
    margin: '10px 0',
    color: '#000',
    fontSize: '14px',
  },
  orderedList: {
    margin: '10px 0',
    paddingLeft: '20px',
    listStyleType: 'decimal',
  }
};

export default PrivacyPolicy;
